import { Dialog, makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Autocomplete,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import isoCountries from "i18n-iso-countries";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getCompanyInfo } from "../../slices/Company/CompanySlice";
import { getRoles, listofRoles } from "../../slices/UserRole/UserRoleSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CustomPhone from "../CustomInputs/CustomPhone";
import CustomTextfield from "../CustomInputs/CustomTextfield";
import Toast from "../ToastContainer/CustomToast";
import CancelButtons from "./CancelButtons";
import SubmitButtons from "./SubmitButtons";

const useStyles = makeStyles((theme) => ({
  dialogbox: {
    "& .css-hlj6pa-MuiDialogActions-root": {
      marginLeft: "320px !important",
    },
    "& .MuiDialog-paper": {
      minWidth: "110vh",
      marginLeft: "100px",
    },
  },
}));

function BulkEmployeeEditDialog({ open, onClose, rowData, onSave }) {
  const classes = useStyles();
  const [firstName, setFirstName] = useState(rowData.firstName);
  const [lastName, setLastName] = useState(rowData.lastName);
  const [email, setEmail] = useState(rowData.email);
  const [AddressLine1, setAddressLine1] = useState(rowData.AddressLine1);
  const [PersonID, setPersonID] = useState(rowData.code);
  const [Country, setCountry] = useState(rowData.Country);
  const [roleId, setRoleId] = useState(rowData.roleId ? rowData.roleId : "");
  const [gender, setGender] = useState(rowData.gender);
  const [phone, setPhone] = useState(rowData.phone ? rowData.phone : "");
  const [phoneCountryCode, setPhoneCountryCode] = useState(
    rowData.phoneCountryCode
  );
  const [phoneNumber, setPhonenumber] = useState(
    rowData.phoneNumber ? rowData.phoneNumber : rowData.phone
  );
  const [phoneInput, setPhoneInput] = useState(
    rowData.phone ? rowData.phoneCountryCode + rowData.phone : ""
  );
  const [code, setCode] = useState(rowData.code);
  const { t } = useTranslation();
  const [roleType, setRoleType] = useState([]);
  const [defaultRole, setDefaultRole] = useState();
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState(null);
  const [defaultGender, setDefaultGender] = useState(null);
  const [roleName, setRoleName] = useState(rowData.roleName);
  const [parentCompnayCountry, setParentCompanyCountry] = useState("");
  const { darkMode } = useContext(ThemeContext);

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 10,
  });

  const [filter, setFilter] = React.useState({
    name: "",
    roleScope: "APPLICATION",
  });

  useEffect(() => {
    loadData(filter, paging);
    if (phoneNumber === "" || phoneNumber === null) {
      loadCompany();
    }
  }, []);

  useEffect(() => {
    if (rowData.roleId != "") {
      const defaultRole = roleType.find((role) => role.id === rowData.roleId);
      if (defaultRole?.id) setSelectedValue(defaultRole);
    }
  }, [rowData.roleId, roleType]);

  const loadData = (filter, paging) => {
    dispatch(getRoles(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0000") {
          const roles = data.data.roles.filter((role) => {
            if (role.code != "DEVICEADMIN") return role;
          });
          setRoleType(roles);
        } else {
          setRoleType([]);
        }
      });
  };

  useEffect(() => {
    if (rowData.gender != "") {
      const value = genderOptions.find(
        (gender) => gender.value === rowData.gender
      );
      if (value) setDefaultGender(value);
    }
  }, [rowData.gender]);

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setPhoneCountryCode("+" + data.dialCode);
    setPhonenumber(value.toString().replace(data.dialCode, ""));
    setPhone(value.toString().replace(data.dialCode, ""));
  };

  const genderOptions = [
    {
      id: "M",
      name: "Male",
      value: "M",
    },
    {
      id: "F",
      name: "Female",
      value: "F",
    },
    {
      id: "O",
      name: "Other",
      value: "O",
    },
  ];

  const handleSave = () => {
    if (firstName === "") {
      Toast(t("USERPROFSCREEN007"), "error");
      return;
    }
    if (lastName === "") {
      Toast(t("USERPROFSCREEN008"), "error");
      return;
    }
    if (email === "") {
      Toast(t("EMAILVALIDATE"), "error");
      return;
    }
    if (PersonID === "") {
      Toast(t("PERSONINFO1"), "error");
      return;
    }

    if (roleId === "") {
      Toast(t("ROLEEMPTYERROR"), "error");
      return;
    }

    onSave({
      ...rowData,
      firstName,
      lastName,
      email,
      AddressLine1,
      PersonID,
      code,
      Country,
      phone,
      phoneNumber,
      phoneCountryCode,
      roleId,
      roleName,
      gender,
    });
    Toast(t("PERSONINFO4"), "success");
    onClose();
  };

  const loadCompany = () => {
    dispatch(getCompanyInfo())
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setParentCompanyCountry(countryCode);
          } else {
            setParentCompanyCountry("us");
          }
        }
      })
      .catch((er) => {});
  };
  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const handleGenderChange = (event, value) => {
    if (value) {
      setGender(value.value);
      setDefaultGender(value);
    } else {
      setGender("");
      setDefaultGender(null);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        fullWidth={true}
        PaperProps={{
          style: {
            borderRadius: "20px !important",
            minWidth: "40vw",
            backgroundColor: darkMode ? "rgb(14, 42, 65)" : "#fff",
            color: darkMode ? "#fff" : "#434547",
          },
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle variant="h4">
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon onClick={onClose} />
          </IconButton>
          <Typography
            style={{
              color: darkMode ? "#fff" : "black",
              fontSize: "20px",
              fontWeight: "450",
            }}
          >
            {t("PERSONINFO5")}
          </Typography>
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        <DialogContent style={{ paddingBottom: "0px" }}>
          <Grid
            container
            justifyContent="center"
            rowSpacing={2}
            columnSpacing={1}
          >
            <Grid item xs={12} sm={6}>
              <CustomTextfield
                type={"text"}
                name="FirstName"
                label={t("USER0001")}
                value={firstName}
                required={true}
                handleChange={(e) => setFirstName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextfield
                type={"text"}
                name="LastName"
                label={t("USER0002")}
                value={lastName}
                required={true}
                handleChange={(e) => setLastName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextfield
                type={"text"}
                name="Email"
                label={t("VISUPDATE0001")}
                value={email}
                required={true}
                handleChange={(e) => setEmail(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomPhone
                placeholder={t("VISUPDATE0002")}
                value={phoneInput}
                specialLabel={false}
                country={parentCompnayCountry}
                handleChange={(value, data, event, formattedValue) =>
                  handlePhoneChange(value, data, event, formattedValue)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextfield
                type={"text"}
                name="PersonID"
                label={t("COMMON140")}
                value={PersonID}
                required={true}
                handleChange={(e) => {
                  setPersonID(e.target.value);
                  setCode(e.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                disablePortal
                options={genderOptions}
                value={defaultGender}
                onChange={handleGenderChange}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                inputProps={{ className: classes.input }}
                renderInput={(params) => (
                  <TextField {...params} label={t("USERPROFSCREEN011")} />
                )}
                sx={{
                  '& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"]': {
                    backgroundColor: "rgb(60, 64, 75)",
                    color: "rgb(242, 130, 76)",
                  },
                  "& .MuiAutocomplete-option.Mui-focused": {
                    backgroundColor: "rgba(60, 64, 75, 0.8)",
                  },
                }}
              />
            </Grid>

            <Grid xs={12} sm={12} item>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                disablePortal
                options={roleType}
                getOptionLabel={(option) => option.name}
                value={selectedValue}
                sx={{
                  width: "100%",
                }}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setRoleId(newValue.id);
                    setSelectedValue(newValue);
                    setRoleName(newValue.name);
                  } else {
                    setRoleId("");
                    setSelectedValue();
                    setRoleName();
                  }
                }}
                renderInput={(params) => <TextField {...params} label="Role" />}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
          }}
        >
          <CancelButtons
            variant="contained"
            color="secondary"
            onClick={onClose}
          >
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON008")}
            </Typography>
          </CancelButtons>
          <SubmitButtons variant="contained" onClick={handleSave}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON007")}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BulkEmployeeEditDialog;
